import RewardService from "@/services/RewardService.js";

export default {
  namespaced: true,
  state: {
    loading: false,
    loadingOverlay: false,
    errors: null,
    rewards: null,
    rewardDetails: null,
    initialPageCount: 0,
    maxPage: 1,
    nextPage: 0,
    prevPage: 0,
    currentPage: 1,
    totalPerPage: 1,
    currentFirstItem: 1,
    currentLastItem: 1,
    redeemMessage: null
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_LOADING_OVERLAY(state, value) {
      state.loadingOverlay = value;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    },
    SET_REWARDS(state, rewards) {
      state.rewards = rewards;
    },
    SET_REWARD_DETAILS(state, rewardDetails) {
      state.rewardDetails = rewardDetails;
    },
    SET_INITIAL_PAGE_COUNT(state, list) {
      state.initialPageCount = list.length;
    },
    SET_PAGINATION(state, pagination) {
      state.totalPerPage = pagination.list.length;
      state.maxPage = pagination.max_page;
      state.prevPage = pagination.prev_page;
      state.nextPage = pagination.next_page;
      state.currentPage = state.prevPage + 1;
      state.currentFirstItem = state.initialPageCount * state.prevPage + 1;
      state.currentLastItem =
        state.currentFirstItem > 0
          ? state.currentFirstItem + state.totalPerPage - 1
          : 0;
    },
    SET_REDEEM_MESSAGE(state, message) {
      state.redeemMessage = message;
    }
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    async getRewards({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        request.param = {
          platform: "web"
        };
        let response = await RewardService.getRewards(request);
        if (request.page == 1) {
          await commit("SET_INITIAL_PAGE_COUNT", response.list);
        }
        commit("SET_REWARDS", response.list);
        commit("SET_PAGINATION", response);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getRewardDetails({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_LOADING_OVERLAY", true);
      commit("SET_REWARD_DETAILS", null);
      try {
        let response = await RewardService.getRewardDetails(request);
        commit("SET_REWARD_DETAILS", response);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
        commit("SET_LOADING_OVERLAY", false);
      }
    },
    async redeemReward({ commit }, request) {
      commit("SET_LOADING", true);
      try {
        const { message } = await RewardService.redeemReward(request);
        commit("SET_REDEEM_MESSAGE", message);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async earnPointsViaECode({ commit }, request) {
      commit("SET_LOADING", true);
      commit("SET_ERRORS", null);

      try {
        const { message } = await RewardService.earnPointsViaECode(request);
        commit("SET_REDEEM_MESSAGE", message);
      } catch (errors) {
        commit("SET_ERRORS", { code: errors.errors.message });
      } finally {
        commit("SET_LOADING", false);
      }
    }
  },
  getters: {
    getRewardById: state => id => {
      return state.rewards.find(reward => reward.uuid === id);
    },
    isLoading: state => {
      return state.loading;
    },
    redeemMessage: state => {
      return state.redeemMessage;
    },
    rewardErrors: state => {
      return state.errors;
    }
  }
};
